export enum APP_COLOR {
   PRIMARY = "PRIMARY",
   SECONDARY = "SECONDARY",
   ACCENT = "ACCENT",
   DISABLED = "DISABLED",
   ERROR = "ERROR",
   GRAY= "GRAY"
}

export enum APP_FONT_SIZE {
   EXTRA_SMALL = "EXTRA-SMALL",
   SMALL = "SMALL",
   MEDIUM = "MEDIUM",
   LARGE = "LARGE",
}